export default __webpack_public_path__ + "static/media/rotatevector.45a7eef2.svg";